import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=0b2bc3fa&scoped=true&lang=html"
import script from "./TicketChat.vue?vue&type=script&lang=js"
export * from "./TicketChat.vue?vue&type=script&lang=js"
import style0 from "./TicketChat.vue?vue&type=style&index=0&id=0b2bc3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2bc3fa",
  null
  
)

export default component.exports